import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology'; // Or Brain icon if available

const ThinkingDisplay = ({ command }) => {
  const thinkingText = typeof command.content === 'string'
    ? command.content.replace(/^\[Thinking\]/i, '').replace(/\[\/Thinking\]$/i, '').trim()
    : JSON.stringify(command.content);

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <PsychologyIcon fontSize="small" sx={{ color: 'text.secondary', mt: 0.5 }} />
      <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
        {thinkingText || '(Thinking...)'}
      </Typography>
    </Box>
  );
};

ThinkingDisplay.propTypes = {
  command: PropTypes.shape({
    content: PropTypes.any,
  }).isRequired,
};

export default React.memo(ThinkingDisplay);